<template>
	<div>
		<el-dialog :visible.sync="showdialog" :title="dialogtitle" :width="width" :append-to-body="true"
		 :close-on-click-modal="false" :destroy-on-close="true">
			<div class="getfeelist">
				<div style="height:100px;text-align:center;">
					<el-form :inline="true" class="demo-form-inline" size="mini">
						<el-form-item :label="feelist_lang.p_name">
							<el-select v-model="p_name" style="width:200px;" :filterable="true">
								<el-option
								     v-for="(item,index) in p_namelist" :key="item.p_name"
								      :label="item.p_name" :value="item.p_name">
								      <span style="float: left">{{ item.p_name }}</span>
									  
								      <span style="float: right;"><i class="el-icon-delete" style="color:#ef7c1e" @click="delpname(item,index)"></i></span>
								    </el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<el-row>
					<el-col :span="11" style="color:transparent">1</el-col>
					<el-col :span="8">
						<el-button type="success" size="mini" @click="sure">{{$lang.label.public.sure}}</el-button>
						<el-button size="mini" @click="showdialog=false" style="margin-left:10px">{{$lang.label.public.cancel}}</el-button>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';	
export default {
	components: {
		
	},
	props: {
		
	},
	data(){
		return{
			showdialog:false,
			dialogtitle:'',
			width:'500px',
			feelist_lang:{},
			p_namelist:[],
			feelist:[],
			p_sys:'',
			p_name:'',
			divclass:'getfeelist',
			feetype:''
		}
	},
	methods:{
		init(param){
			this.p_namelist=[];
			this.feelist=[];
			this.p_name='';
			this.p_sys='';
			this.feetype='';
			debugger
			//传费用明细
			if(param.p_sys!=undefined)
				this.p_sys=param.p_sys;
			if(param.feetype!=undefined){
				this.feetype=param.feetype;
			}
			if(param.dialogtitle!=undefined)
				this.dialogtitle=param.dialogtitle;	
			//this.$tool.loading(this.$lang.label.public.loading, this.divclass);
			var that=this;
			this.$public.GetLanguageByMode('feelist',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.feelist_lang=that.$lang.label.feelist;
					if(that.feelist_lang[param.dialogtitle]!=undefined)
						that.dialogtitle = that.feelist_lang[param.dialogtitle];	
				}
				that.getfeelistname();
			});
		},
		getfeelistname(){
			var that=this;
			var feetype='应付';
			if(this.feetype==2)
				feetype='应收';
			var paraminfo={
				p_sys:this.p_sys,
				feetype:feetype,
				token:localStorage.getItem('token'),
				domain:this.$apiprototype.WebServer
			};
			this.$apipost.get.GetFeelistTemp({ paraminfo: paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.list!=undefined){
						if(res.list.length>0){
							that.showdialog=true;
							that.feelist=res.list;
							res.list.forEach(e=>{
								var list=that.p_namelist.filter(function(b){
									return b.p_name==e.p_name;
								});
								if(list.length==0){
									that.p_namelist.push({p_name:e.p_name});
								}
							});
							if(that.p_namelist.length>0)
								that.p_name=that.p_namelist[0].p_name;
						}
						else{
							this.$tool.message(this.feelist_lang.nofeelist, 2);
						}
					}else{
							this.$tool.message(this.feelist_lang.nofeelist, 2);
						}
				}else{
							this.$tool.message(this.feelist_lang.nofeelist, 2);
						}
			});
		},
		sure(){
			var that=this;
			if(this.p_name==''){
				this.$tool.message(this.feelist_lang.p_nameempty, 0);
				return false;
			}
			var list=that.feelist.filter(function(b){
				return b.p_name==that.p_name;
			});
			if(list.length>0){
				 this.$confirm(this.feelist_lang.feelistcallback, this.$lang.label.public.suretips, 
				 {
					  distinguishCancelAndClose: true,
					  confirmButtonText:this.feelist_lang.replace,
					  cancelButtonText: this.feelist_lang.added
				 }).then(() => {
							//debugger
							this.$emit('getfeecallback',{feelist:list,type:1,feetype:that.feetype});
							this.showdialog=false;
						  })
						  .catch(action => {
							  if(action=='cancel'){
								  debugger
								  this.$emit('getfeecallback',{feelist:list,type:0,feetype:that.feetype});
								  this.showdialog=false;
						  }
					});
				
			}
			else{
				this.$tool.message(this.feelist_lang.nofeelist, 0);
			}
		},
		delpname(item,index){
			var feetype='应付';
			if(this.feetype==2)
				feetype='应收';
			var that=this;
			this.$confirm(this.$lang.label.public.deletetips, this.$lang.label.public.remind, {
				confirmButtonText:this.$lang.label.public.sure,
				cancelButtonText: this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
						var paraminfo={
							p_name:item.p_name,
							p_sys:this.p_sys,
							feetype:feetype,
							token:localStorage.getItem('token')
						}
						this.$apipost.post.delfeelisttemp({paraminfo: paraminfo}).then(res => {
							if(res.state=='1'){
								//debugger
								that.$tool.message(that.$lang.label.public.inoperationsuccess, 1);
								that.p_namelist.splice(index,1);
								
								that.feelist.forEach(e=>{
									that.feelist.splice(that.feelist.findIndex(b => b.p_name==item.p_name), 1);										
								});
								if(that.p_name==item.p_name)
									that.p_name='';
								if(that.p_namelist.length==0)
									that.showdialog=false;
								//console.log('feelist'+JSON.stringify(that.feelist));
							}
							else{
								if(res.errorcode!=undefined){
									if(that.$lang.label.public[res.errorcode]!=undefined)
										that.$tool.message(that.$lang.label.public[res.errorcode], 0);
									else
										that.$tool.message(res.message, 0);
								}
								else
								  that.$tool.message(res.message, 0);
							}
						});
					  })
					  .catch(action => {
						 
						});
		}
	}
}
</script>

<style>
</style>